import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'co0020',
    ecrans: ['00-2']
});
